import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import ZoomListPage from "../../components/ZoomMeetings/ZoomMeetingList";


const ZoomPageList = () => {
  return (
    <>


        {/* Breadcrumb */}
        

        {/* UsersListLayer */}
        <ZoomListPage/>

    </>
  );
};

export default ZoomPageList; 